<template>
  <product-management state="1" />
</template>
<script>
export default {
  components: {
    productManagement: () => import('../productManagement/index.vue')
  }
}
</script>